<template>
  <div class="loading-container popup-appstore" effect="scale" :class="{'visible': state == 1, 'visible active': state == 2}">
    <div class="popup popup-appstore">
      <div class="popup-body">
        <div class="title">任务已开始</div>
        <div class="subtitle">请在桌面打开App Store下载应用</div>
        <img class="bg" src="//cdn.hongbaoxd.com/images/d826046c57b97f3ab5f1234bdf8b0df0.png" alt="">
      </div>
      <div class="close" @click="hide()">
        <img src="//cdn.hongbaoxd.com/images/4da3039bc3c0f6ece75d0f990df76359.png" alt="">
      </div>
    </div>
  </div>
</template>
<style lang='scss' scoped>
  @import "../../scss/variables";
  @import "../../scss/mixins";

  .loading-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 13;
    display: -webkit-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -moz-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -moz-align-items: center;
    align-items: center;
    -webkit-transition: opacity .2s linear;
    transition: opacity .2s linear;
    visibility: hidden;
    opacity: 0;

    &.visible {
      visibility: visible;
      background-color: rgba(0, 0, 0, 0.65);
    }

    &.active {
      opacity: 1;
    }
  }

  .popup-appstore {
    .popup-appstore {
      width: 275px !important;
      height: 389px !important;
      background-color: transparent !important;

      .popup-body {
        text-align: center;
        color: #3a3a3a;
        border-radius: 4px;
        position: relative;
        width: 275px !important;
        height: 319px !important;
        padding: 26px 0 0 !important;
        background-color: #ffffff;

        .title {
          height: 22px;
          line-height: 22px;
          font-size: 16px;
          margin-bottom: 6px;

          @include semibold();
        }

        .subtitle {
          font-size: 13px;
          height: 20px;
          line-height: 20px;
          margin-bottom: 20px;

          @include regular();
        }

        .bg {
          width: 240px;
          height: 190px;
        }
      }
    }

    .close {
      text-align: center;
      margin-top: 40px;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }
</style>
<script>
  function preventDefault (e) {
    e.preventDefault()
  }

  export default {
    data () {
      return {
        state: 0
      }
    },

    methods: {
      show () {
        this.state = 1
        setTimeout(() => {
          this.state = 2
        })
        document.addEventListener('touchmove', preventDefault)
      },

      hide () {
        this.state = 1
        setTimeout(() => {
          this.state = 0
        }, 300)
        document.removeEventListener('touchmove', preventDefault)
      }
    }
  }
</script>
